<template>
  <div style="padding-bottom: 30px;">
    <div style="font-size: 14px; position: fixed; display: inline-block">
      <label>Attachment: </label>
    </div>
    <div class='upload-panel' style="display: inline-block; position: fixed; margin-left: 100px;">
      <el-upload ref='uploadComponent'
        :action='handleActionUrl'
        :show-file-list='true'
        :on-change='handleChange'
        :on-success='handleSuccess'
        :on-error='handleError'
        :multiple=false
        :limit='1'
        :before-upload='validateFileSize'
        :on-exceed='handleExceed'
        :auto-upload='true'
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :headers="{'Authentication-Token': jwtToken}"
        :file-list='fileList'>
        <el-button class="select-file-button">Select File</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
import CookiesHelper from '@/utils/cookiesHelper'
import Constant from '@/common/Constant';
import getBaseUrl from '@/utils/apiBaseUrlHelper';
import CommonHelper from '@/utils/commonHelper';

export default {
  props: {
    defaultUploadFileList: {
      type: Array,
      default: () => []
    },
    viewOnly: {
      type: Boolean,
      default: () => false
    },
    target: {
      type: String,
      default: () => 'ta'
    },
    userType: {
      type: String
    },
    fileClear: {
      type: Boolean
    }
  },
  name: 'UpLoadFile',
  data () {
    return {
      fileList: [],
      allFileList: [],
      fileName: '',
      assessmentType: '',
      jwtToken: CookiesHelper.get('JWT-TOKEN-HEADER')
    };
  },
  methods: {
    handleChange (file, fileList) {
      this.fileName = file.name;
      this.fileList = fileList;
      let index = this.allFileList.findIndex(item => {
        return file.uid === item.file.uid;
      });
      if (index === -1) {
        file.isUpload = false;
        this.allFileList.push({
          file: Object.assign({}, file),
          description: {
            id: '',
            description: ''
          }
        });
      }
    },
    validateFileSize (file) {
      this.fileName = file.name;
      const extension = file.name.split('.')[1] === 'xls';
      const extension2 = file.name.split('.')[1] === 'xlsx';
      if (!extension && !extension2) {
        this.$message.error('Only Excel File is Allow.');
        return false;
      } else {
        return true;
      }
    },
    handleSuccess (response, file, fileList) {
      this.fileList = fileList;
      if (response.code === Constant.POPUP_EXCEPTION_CODE && response.msg !== '') {
        this.$alert(response.msg, 'Warning', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$emit('closeUpload');
            this.$refs.uploadComponent.clearFiles();
            this.fileList = [];
          }
        });
      } else {
        let assessmentInfo = response.data;
        sessionStorage.setItem('assessmentInfo', JSON.stringify(assessmentInfo));
      }
    },
    handleError (response) {
      CommonHelper.handleExceptionForComponentRequest(response);
    },
    handleExceed () {
      this.$message.error('You cannot add more than 1 entries in Attach file.');
    },
    handleRemove (file, fileList) {
      this.fileList = fileList;
      console.log(file, fileList);
    },
    beforeRemove (file, fileList) {
      return this.$alert(`You have successfully removed the file ${file.name}.`, {
        confirmButtonText: 'OK'
      });
    }
  },
  computed: {
    getAttachmentData () {
      let tmp = [];
      this.allFileList.forEach(file => {
        if (file.file.isUpload === true) {
          tmp.push(file.description);
        }
      });
      return tmp;
    },
    handleActionUrl () {
      if (this.assessmentType === Constant.TYPE_STAKEHOLDER) {
        return `${getBaseUrl()}/esg/security/stakeholder/questionnaire/upload`;
      } else {
        return `${getBaseUrl()}/esg/security/vendor/assessment/upload`;
      }
    }
  },
  mounted () {
    if (this.defaultUploadFileList) {
      this.allFileList = this.defaultUploadFileList;
    }
    this.assessmentType = this.userType;
  },
  watch: {
    fileClear: function (newVal, oldVal) {
      this.fileClear = newVal;
      this.$refs.uploadComponent.clearFiles();
      this.fileList = [];
    }
  }
};
</script>

<style lang='scss' scoped>
.upload-panel {
  text-align: left;
  margin-top:-20px !important;
}
.el-input{
  margin-left:10px;
  width: 250px;
}
.select-file-button:focus{
  border-color: #5e89ed;
  background-color: #5e89ed;
  color: #f4f5f7;
}

.el-upload-list {
  position: absolute !important;
  bottom: 0 !important;
  left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/UploadAssessment.vue